var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "main-component", style: _vm.up },
    [
      _c(
        "div",
        { staticClass: "first-section", style: _vm.up },
        [
          _c(
            "video",
            {
              ref: "mobile_video",
              staticClass: "videoFull",
              attrs: {
                id: "mobile_video",
                src: _vm.firstPage[0].video,
                loop: "",
                playsinline: "",
                "webkit-playsinline": "",
                preload: "",
                width: "100%",
                "webkit-playsinline": "true"
              }
            },
            [_c("source", { attrs: { type: "video/mp4" } })]
          ),
          _vm.isA
            ? _c("nuxt-link", {
                staticClass: "btn-start",
                attrs: {
                  to:
                    "/video/?url=" +
                    _vm.firstPage[0].video +
                    "&poster=" +
                    _vm.firstPage[0].mainImg
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c("div", { staticClass: "second-section" }, [
        _c(
          "div",
          { staticClass: "second-wrap" },
          [
            _c("p", { staticClass: "project-name" }, [_vm._v(_vm._s(_vm.pro))]),
            _vm._l(_vm.descPageData, function(item, index) {
              return _c(
                "div",
                {
                  staticClass: "project-show",
                  class: {
                    right: index === 0 || index === 2,
                    bottom: index === 0 || index === 1
                  }
                },
                [
                  _c(
                    "nuxt-link",
                    {
                      attrs: { to: "/project/" + item.id + "?lang=" + _vm.lang }
                    },
                    [
                      _c("img", { attrs: { src: item.mainImg, alt: "" } }),
                      _c("div", { staticClass: "project-modal" }, [
                        _c("div", { staticClass: "modal-text" }, [
                          _c("hr"),
                          _c("h2", [_vm._v(_vm._s(item.title))]),
                          _c("h4", [_vm._v(_vm._s(item.time))])
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            _c(
              "nuxt-link",
              {
                staticClass: "indexproject-more_link",
                attrs: { to: "/project?lang=" + _vm.lang }
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.more))]),
                _c("i", { staticClass: "icon icon-arrowright" })
              ]
            )
          ],
          2
        )
      ]),
      _c(
        "div",
        { staticClass: "third-section", style: _vm.up },
        [
          _c("common-title", {
            staticClass: "thirdText",
            attrs: { title: _vm.thirdPage[0].content, describe: "" }
          }),
          _c("div", { staticClass: "videoFixed" }, [
            _c(
              "video",
              {
                ref: "mobile_videos",
                staticClass: "hidden videoFull",
                attrs: {
                  id: "mobile_videos",
                  loop: "",
                  "x5-playsinline": " ",
                  playsinline: " ",
                  "webkit-playsinline": " ",
                  "x5-video-player-type": "h5",
                  "x5-video-player-fullscreen": "true",
                  preload: "",
                  width: "100% "
                }
              },
              [
                _c("source", {
                  attrs: { src: _vm.thirdPage[0].video, type: "video/mp4 " }
                })
              ]
            )
          ]),
          _vm.isA
            ? _c("nuxt-link", {
                staticClass: "btn-start",
                attrs: {
                  to:
                    "/video/?url=" +
                    _vm.thirdPage[0].video +
                    "&poster=" +
                    _vm.thirdPage[0].mainImg
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "four-section ", style: _vm.up },
        [
          _c("common-title", {
            attrs: { title: _vm.fourPage[0].content, describe: "" }
          })
        ],
        1
      ),
      _c("common-footer", { staticClass: "index-footer " })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a183b29", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a183b29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2a183b29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/index.vue
// module chunks = 4